import React from "react";

interface Props {
  graphStatistics: any;
  setModalOption: any;
  projectData: any;
}

export const GraphModule: React.FC<Props> = ({
  graphStatistics,
  setModalOption,
  projectData,
}) => {
  let tags = ["#books", "#movies", "#entertainment", "#test", "#test", "#test"];
  return (
    <div className="p-4">
      <div className="m-2 ">
        <div className="font-bold text-lg ">{projectData.name}</div>
        <p className="text-gray-700 text-sm mb-2 ">{projectData.description}</p>

        <div className="flex flex-row justify-between">
          <label className="block text-sm font-bold ">
            Graph Accesability:
          </label>
          <p className="text-gray-700 text-sm">
            {projectData.public ? "Public" : "Private"}
          </p>
        </div>
        <div className="flex flex-row justify-between">
          <label className="block text-sm font-bold ">Creator</label>
          <p className="text-gray-700 text-sm">By {projectData.owner}</p>
        </div>
        <div className="flex flex-row justify-between">
          <label className="block text-sm font-bold ">Version</label>
          <p className="text-gray-700 text-sm"> {projectData.version}</p>
        </div>

        <div className="flex flex-row justify-between">
          <label className="block text-sm font-bold"> Total Nodes: </label>
          <p className="text-gray-700 text-sm">
            {graphStatistics["Total Nodes"]}
          </p>
        </div>
        <div className="flex flex-row justify-between">
          <label className="block text-sm font-bold">Total Edges: </label>
          <p className="text-gray-700 text-sm">
            {graphStatistics["Total Edges"]}
          </p>
        </div>
        <div className="flex flex-row justify-between">
          <label className="block text-sm font-bold">
            Number of Clusters:{" "}
          </label>
          <p className="text-gray-700 text-sm">
            {graphStatistics["Total Clusters"]}
          </p>
        </div>
        <div className="flex flex-row justify-between">
          <label className="block text-sm font-bold">
            Average Graph Connectivity:{" "}
          </label>
          <p className="text-gray-700 text-sm">
            {parseFloat(graphStatistics["Average Connections"]).toFixed(3)}
          </p>
        </div>

        <div className=" overflow-x-auto">
          <label className="block text-sm font-bold mb-2">Tags </label>
          <div className="grid grid-cols-3">
            {tags.map((name: any, key: any) => (
              <div
                key={key}
                className=" text-center bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2 mb-2 w-25 overflow-x-hidden text-ellipsis"
              >
                {name}
              </div>
            ))}
          </div>
        </div>

        <hr className="my-2" />
      </div>

      <button
        onClick={() => setModalOption("Add Node")}
        className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline w-full "
      >
        {" "}
        Create New Node
      </button>
    </div>
  );
};
